
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import { MainModule } from './app/core/main.module';
import moment from 'moment';
import 'moment/locale/es';
import 'moment-timezone';
moment.locale('es');
moment.tz.setDefault('America/Bogota');

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(MainModule)
  .catch(err => console.error(err));
